import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { Title } from '@/pages/menu-managements/services/title';
import { MenuManagementBrandMenuHourService } from '@/services/BrandMenuHour/MenuManagementBrandMenuHourService';

export type MenuManagementBrandMenuHourSearchParams = {
  associate_brand_id: string;
};

export type SearchBrandMenuHourResponse = {
  id: string;
  title: Title;
};

export const useMenuManagementBrandMenuHourSearch = async (
  params: MenuManagementBrandMenuHourSearchParams
): Promise<SearchBrandMenuHourResponse[]> => {
  const menuManagementBrandMenuHourService =
    new MenuManagementBrandMenuHourService(getClient());
  try {
    return await menuManagementBrandMenuHourService.search(params);
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
